function broadcast(componentName, eventName, params) {
  this.$children.forEach(child => {
    const name = child.$options.name;

    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      // todo 如果 params 是空数组，接收到的会是 undefined
      broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}
export default {
  methods: {
    dispatch(componentName, eventName, params) {
      let parent = this.$parent || this.$root;
      let name = parent.$options.name;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.name;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    broadcast(componentName, eventName, params) {
      broadcast.call(this, componentName, eventName, params);
    },
    addressFilter(value, all = false) {
      if (value.split('[$]').length > 1) {
        if (all) {
          return value.split('[$]')[0] + value.split('[$]')[1];
        } else {
          return value.split('[$]')[1];
        }
      } else {
        return value;
      }
    },
    currency(value, _currency, decimals) {
      value = parseInt(value);
      if (!isFinite(value) || (!value && value !== 0)) return '';
      _currency = _currency != null ? _currency : '$';
      if (typeof value === 'number' && value % 1 === 0) {
        decimals = 0;
      } else {
        decimals = decimals != null ? decimals : 2;
      }
      // decimals = decimals != null ? decimals : 2;
      let stringified = Math.abs(value).toFixed(decimals);
      let _int = decimals > 0 ?
        stringified.slice(0, -1 - decimals) :
        stringified;
      let i = _int.length % 3;
      let head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
      let _float = decimals > 0 ? stringified.slice(-1 - decimals) : '';
      let sign = value < 0 ? '-' : '';
      let digitsRE = /(\d{3})(?=\d)/g;
      return (
        sign +
        _currency +
        head +
        _int.slice(i).replace(digitsRE, '$1,') +
        _float
      );
    },
  },
};